export enum WarningMessageEnum{
    NewUserTerminationMessage = "Your session has been terminated. \nMaintenance is in progress. \nPlease check back later.",
    ExistingUserTerminationMessage = "Your session has been terminated. \nMaintenance is in progress. \nPlease check back later.",
    SiteDownLabelOne = "The site is currently experiencing technical difficulties.",
    SiteDownLabelTwo = "We are working to resolve the issue.",
    SiteDownLabelThree = "Thank you for your patience and understanding.",
    LandingPageTerminationPopup = "Maintenance is in progress. \n Please check back later."
}